import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import featureFlags from "constants/featureFlags";
import { getGroupedDeals, clearStore } from "../deal.store";
import DealLite from "./DealLite";

class DealLiteWrapper extends Component {
  componentDidMount() {
    if (this.us939FeatureFlag()) {
      this.props.getGroupedDeals(this.props.match.params.dealId);
    }
  }

  componentWillUnmount() {
    if (this.us939FeatureFlag()) {
      this.props.clearStore();
    }
  }

  us939FeatureFlag = () =>
    this.props.flags[featureFlags.US939_DEAL_LITE_NAVIGATION];

  render() {
    return (
      <DealLite
        key={this.props.match.params.dealId}
        us939FeatureFlag={this.us939FeatureFlag()}
      />
    );
  }
}

export default compose(
  withLDConsumer(),
  connect(null, { getGroupedDeals, clearStore })
)(DealLiteWrapper);
